import styled from 'styled-components';

export const ExpandableBox = styled.div`
  position: relative;
  display: flex;
  overflow: visible;

  .container {
    height: 100%;
    display: flex;
    position: relative;
    width: calc(100% - 5px);
    z-index: 9;
  }
`;
